import MapComponent from "./MapComponent";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import React, { Component } from "react";
import CommonTile from "./CommonTile";
import Footer from "./Footer";
import Image from 'mui-image'
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Speedometer from 'react-d3-speedometer';
import PlayIcon from '@mui/icons-material/PlayCircle';
import _ from "lodash";

// Top Marketing
// Strong Negoitaors
// Experiaced Team
// Stagging & Photography
// Resources
// Contact Your Realtor

class FeaturedListingsMultifamily extends Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.markers = [];

    this.state = {
      selectedEntry:  0,
      pictureHeight: "100%",
      pictureWidth: "60%",
      featured: [],
      builders:[
        {
          id:"1",
          name:"Radisson",
          town:"Baldwinsville"
        },
        {
          id:"2",
          name:"Kimbrook",
          town:"Clay"
        },
        {
          id:"3",
          name:"Layton Valley",
          town:"Clay"
        },
        {
          id:"4",
          name:"Bayberry",
          town:"Liverpool"
        },
        {
          id:"5",
          name:"Pinegate",
          town:"Clay"
        },
        {
          id:"6",
          name:"Fairways",
          town:"clay"
        },
        {
          id:"7",
          name:"Cherry Estate",
          town:"clay"
        },
        {
          id:"8",
          name:"Hark Farms",
          town:"Baldwinsville"
        },
      ],
        
    }
  }


  toggleFeaturedListingsMultifamily = () => {
    this.setState({
      FeaturedListingsMultifamily: !this.state.FeaturedListingsMultifamily,
    });
  };

  toggleContactForm = () => {
    this.setState({
      showListing: null,
      contactForm: !this.state.contactForm,
      contactReason: "Lets Connect",
    });
  };

  toggleRequestForm = (listing) => {
    this.setState({
      showListing: this.props.listings[0],
      contactForm: !this.state.contactForm,
      contactReason: "Request A Showing",
    });
  };

  getContactTile = () => {
    let tile = {
      id: "1",
      image: "profilepics/contact-profile.png",
      tag: null,
      name: "Let Me Guide You Through The Process",
      summary:
      "I will work to ensure that your journey is as smooth and stress-free as possible. Whether you are a first-time buyer or an experienced home owner, I am here to support you every step of the way.",
      download: true,
    }
  
    return (
      <React.Fragment>
            <Grid
              item
              sx={{
                width: "100%",
                padding: {
                  xs:"10px",
                  sm:"10px",
                  md:"10px",
                  lg:"20px",
                  xl:"20px"
                },
                height: {
                  xl: "100%",
                  lg: "100%",
                  md: "100%",
                  sm: "100%",
                },
                
              }}
              xl={4}
              lg={4}
              md={4}
              sm={6}
              xs={12}
            >
              <CommonTile
                animationType={null}
                animationTime={null}
                tagPicture={null}
                tagTxt={tile.tag}
                tagTxtColor={"black"}
                tagTxtSize={["12px", "12px", "16px"]}
                tagTxtType={"bold"}
                tagTxtAlign={"center"}
                tagVerticalAlign={"flex-start"}
                tagHorizontalAlign={"flex-end"}
                tagBgColor={"#73be73"}
                tagBorder={"1px solid black"}
                tagBorderRadius={"15px"}
                topPadding={"5px"}
                topPicture={tile.image}
                topPictureAlign={"100% 100%"}
                topPictureSize={"contain"}
                topTxt={null}
                topTxtColor={"black"}
                topTxtSize={["12px", "12px", "12px"]}
                topTxtType={"bold"}
                topTxtAlign={"left"}
                topBgColor={"rgba(255,255,255,1)"}
                topHeight={["225px", "60%", "60%"]}
                topHorizontalAlign={"center"}
                topVerticalAlign={"flex-end"}
                topGraphType={null}
                topGraphData={null}
                mdlPadding={"5px"}
                mdlPicture={null}
                mdlPictureAlign={null}
                mdlTxt={tile.name}
                mdlTxtColor={this.props.theme.bannerTextColor}
                mdlTxtSize={["1rem", "1rem", "1.2rem"]}
                mdlTxtType={"bold"}
                mdlTxtAlign={"left"}
                mdlHorizontalAlign={"center"}
                mdlVerticalAlign={"center"}
                mdlBgColor={this.props.theme.bannerColor}
                mdlBorder={"1px solid black"}
                mdlHeight={["50px", "10%", "10%"]}
                mdlGraphType={null}
                mdlGraphData={null}
                btmPadding={"5px"}
                btmPicture={null}
                btmPictureAlign={null}
                btmTxt={tile.summary}
                btmTxtColor={this.props.theme.textColor}
                btmTxtSize={["1rem", ".8rem", "1rem"]}
                btmTxtType={"bold"}
                btmTxtAlign={"left"}
                btmTxtLineHeight={"1.25"}
                btmHorizontalAlign={"flex-start"}
                btmVerticalAlign={"flex-start"}
                btmBgColor={"white"}
                btmBorder={"1px solid black"}
                btmHeight={["150px", "30%", "30%"]}
                btmGraphType={null}
                btmGraphData={null}
                border={"1px solid black"}
                shadow={4}
                downloads={""}
                linksTo={""}
                growTime={4000}
                padding={"0px"}
                borderRadius={"20px"}
                bgcolor={"rgba(255,255,255,1)"}
              />
            </Grid>
      </React.Fragment>
    );
  };
  

  createSection = (section) => {
    return (
      <Grid
        container
        ref={section}
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{
          background: "rgba(255,255,255,.75)",
          height: "100%",
          width: "100%",
          borderBottom: "1px solid #333333",
        }}
      >

        <Grid
          item
          sx={{
            width: "100%",
            height: {
              xl: "80%",
              lg: "75%",
              md: "75%",
              sm: "75%",
            },
            paddingTop: "10px",
            fontSize: "2rem",
          }}
          xs={12}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{              
              height: "100%",
              width: "100%",
            }}
          >

           
            {this.state.featured.length > 0 ? this.getFeaturedListingsTile(this.state.featured[0]) : this.getContactTile()}
            {this.state.featured.length > 1 ? this.getFeaturedListingsTile(this.state.featured[1]) : this.getContactTile()}
            {this.state.featured.length > 2 ? this.getFeaturedListingsTile(this.state.featured[2]) : this.getContactTile()}

          </Grid>
        </Grid>
        {this.getIdxTile()}
        <Grid
          item
          sx={{
            width: "100%",
            height: {
              xl: "10%",
              lg: "10%",
              md: "10%",
              sm: "10%",
            },
            padding: "5px",
            fontSize: "2rem",
          }}
          xs={12}
        >
          <Footer theme={this.props.theme}  />
        </Grid>
      </Grid>
    );
  };

 
  getFeaturedListingsTile = (tile) => {

    return (
            <Grid
              item
              sx={{
                width: "100%",
                padding: "15px",
                height: {
                  xl: "100%",
                  lg: "100%",
                  md: "100%",
                  sm: "100%",
                },
              }}
              xl={4}
              lg={4}
              md={4}
              sm={12}
              xs={12}
            >
              <CommonTile
                uid={tile.ListingId}
                animationType={null}
                animationTime={null}
                tagTopRightIcon={ 
                  this.props.favorites.some(obj => obj.mls === tile.mls) ? 
                  <React.Fragment>
                    <Image src={"logos/loveit-logo.png"} bgColor="rgba(255,255,255,0)" sx={{"&:hover": {cursor: "pointer"}}} onClick={() => this.props.markAsFavorite(tile)} fit="fit" height={35} width={55} duration={200}/>              
                    </React.Fragment>              
                    :
                    <React.Fragment>
                    <Image src={"logos/loveit-gray.png"} bgColor="rgba(255,255,255,0)" sx={{"&:hover": {cursor: "pointer"}}} onClick={() => this.props.markAsFavorite(tile)} fit="fit" height={35} width={55} duration={200}/>              
                    </React.Fragment>                           
                }
                tagTopRightTxt={null}
                tagTopRightPadding={"2px 2px 2px 2px"}
                tagTopRightTxtColor={"black"}
                tagTopRightTxtSize={["1rem", "1rem", "1rem"]}
                tagTopRightPaddingRight={"2px"}
                tagTopRightPaddingTop={"2px"}
                tagTopRightTxtType={"bold"}
                tagTopRightTxtAlign={"center"}
                tagTopRightBgColor={"rgba(255,255,255,0)"}
                tagTopRightBorder={"0px solid white"}
                tagTopRightBorderRadius={["0px","0px","0px","0px"]}
                tagTopRightCallback={null}

                tagBottomRightIcon={
            tile.ListAgentMlsId === "WILLSDO" ? <Image src={"logos/listedby-donna.png"} bgColor="rgba(255,255,255,0)" fit="fit" height={20} width={60} duration={200}/> : null
          }
          tagBottomRightTxt={
            null
          }
                tagBottomRightPadding={"5px 10px 5px 10px"}
                tagBottomRightTxtColor={"black"}
                tagBottomRightTxtSize={[".75rem", ".75rem", ".75rem"]}
                tagBottomRightPaddingRight={"0px"}
                tagBottomRightPaddingBottom={"0px"}
                tagBottomRightTxtType={"bold"}
                tagBottomRightTxtAlign={"center"}
                tagBottomRightBgColor={ "rgba(255, 255, 255, 1)"}
                tagBottomRightBorder={"1px solid white"}
                tagBottomRightBorderRadius={["10px", "0px", "0px", "0px"]}
                tagBottomRightCallback={null}

                tagTopLeftIcon={null}
                tagTopLeftTxt={
                  tile.status
                }
                tagTopLeftPadding={"5px 10px 5px 10px"}
                tagTopLeftTxtColor={tile.status === "Available" ? this.props.theme.bannerTextColor : "black"}
                tagTopLeftTxtSize={[".75rem", ".75rem", ".75rem"]}
                tagTopLeftPaddingLeft={"0px"}
                tagTopLeftPaddingTop={"15px"}
                tagTopLeftTxtType={"bold"}
                tagTopLeftTxtAlign={"center"}
                tagTopLeftBgColor={tile.status === "Available" ? "rgba(12,101,58,.95)" : "rgba(255, 165, 0,.95)"}
                tagTopLeftBorder={"0px solid black"}
                tagTopLeftBorderRadius={["0px", "20px", "20px", "0px"]}

                tagBottomLeftIcon={null}
                tagBottomLeftTxt={tile.videos.length > 0 ?                 
                  <Button variant="filled" sx={{padding:"5px 10px 5px 10px", textTransform: "none", fontSize:".75rem", color:this.props.theme.bannercolor}} startIcon={<PlayIcon sx={{color:this.props.theme.bannerColor}}/>}>
                    Video
                  </Button>                
                  : null
                }
                tagBottomLeftPadding={"0px"}
                tagBottomLeftTxtColor={this.props.theme.bannerColor}
                tagBottomLeftTxtSize={["1rem", "1rem", ".75rem"]}
                tagBottomLeftPaddingLeft={"0px"}
                tagBottomLeftPaddingBottom={"5px"}
                tagBottomLeftTxtType={"bold"}
                tagBottomLeftTxtAlign={"center"}
                tagBottomLeftBgColor={"rgba(255,255,255,1)"}
                tagBottomLeftBorder={"0px solid black"}
                tagBottomLeftBorderRadius={["0px", "10px", "10px", "0px"]}
                tagBottomLeftCallback={this.showListingReport}

                topCallback={this.showListingReport}
                topPadding={"0px"}
                topPicture={null}
                topPictureAlign={"center"}
                topPictureSize={"cover"}
                topTxt={null}
                topTxtColor={"white"}
                topTxtSize={["1.5rem", "1.5rem", ".75rem"]}
                topTxtType={"bold"}
                topTxtAlign={"left"}
                topVerticalAlign={"flex-end"}
                topHorizontalAlign={"flex-start"}
                topBgColor={"rgba(255,255,255,0)"}
                topHeight={["250px", "75%", "75%"]}
                topGraphType={null}
                topGraphData={null}
                topWidget={
                  <Image src={tile.image} fit="cover" duration={200} />
                }

                mdlTagIcon={null}
                mdlTagTxt={null}
                mdlTagPadding={"0px"}
                mdlTagTxtColor={"black"}
                mdlTagTxtSize={["1.5rem", "1.5rem", "1.5rem"]}
                mdlTagPaddingRight={"4px"}
                mdlTagPaddingTop={"2px"}
                mdlTagTxtType={"bold"}
                mdlTagTxtAlign={"center"}
                mdlTagBgColor={"rgba(255,255,255,0)"}
                mdlTagBorder={"0px solid black"}
                mdlTagBorderRadius={"5px"}                
                mdlPadding={"0px"}
                mdlPicture={null}
                mdlPictureAlign={null}
                mdlTxtLineHeight={1.5}
                mdlTxt={null}

                mdlWidget={
                  
                  <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    background: "rgba(255,255,255,0)",
                    height:"100%",
                    width:"100%",     
                    border: "0px solid #AAAAAA",
                  }}
                >
                    <Grid
                      item
                      sx={{
                        background: "rgba(255,255,255,0)",
                        overflowX:"hidden",
                        textAlign:"left",
                        fontSize: {
                          xs:"1rem",
                          sm:"1rem",
                          md:"1rem",
                          lg:"1rem",
                          xl:"1rem",
                        },
                        fontWeight:"normal",
                      }}
                      xs={10}
                    >

                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          background: "rgba(255,255,255,0)",
                          height:"100%",
                          width:"100%",     
                          border: "0px solid #AAAAAA",
                        }}
                      >
                        <Grid
                          item
                          sx={{
                            overflowX:"hidden",
                            textAlign:"left",
                            fontSize: {
                              xs:"1rem",
                              sm:"1rem",
                              md:"1rem",
                              lg:"1rem",
                              xl:"1rem"
                            },
                            fontWeight:"normal",
                          }}
                          xs={12}
                        >
                            <Box sx={{
                              fontSize:{
                              xs:"1.25rem",
                              sm: "1.25rem",
                              md:"1.25rem",
                              lg:"1.25rem",
                              xl:"1.25rem",
                              },
                              paddingLeft: {
                                xs:"10px",
                                sm:"10px",
                                md:tile.ListAgentMlsId === "WILLSDO" ? "5px" : "10px",
                                lg:"10px",
                                xl:"10px",
                              },
  
                              fontWeight:"bold", display:"inline"}} >
                          {tile.price}
                          </Box>
                            &nbsp;|&nbsp;
                          {tile.details.sqf} sf &nbsp;|&nbsp;
                          {tile.details.bed} bd&nbsp;|&nbsp;
                          {tile.details.bath} ba
                        </Grid>                           

                        <Grid
                          item
                          sx={{
                            overflowX:"hidden",
                            textAlign:"left",
                            paddingLeft: {
                              xs:"10px",
                              sm:"10px",
                              md:tile.ListAgentMlsId === "WILLSDO" ? "5px" : "10px",
                              lg:"10px",
                              xl:"10px",
                            },
                            fontSize: {
                              xs:"1rem",
                              sm: "1rem",
                              md:"1rem",
                              lg:"1rem",
                              xl:"1rem",
                            }
                          }}
                          xs={12}
                        >
                        {tile.address}
                      </Grid>                 
                    </Grid>                 
                    </Grid>                 

                    <Grid
                      item
                      sx={{
                        overflowX:"hidden",
                        textAlign:"left",
                        fontSize: {
                          xs:"1rem",
                          sm:"1rem",
                          md:"1rem",
                          lg:"1rem",
                          xl:"1rem",
                        },
                        fontWeight:"normal",
                        height:"100%",
                        width:"100%",     
                      }}
                      xs={2}
                    >

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="flex-end"
                      sx={{
                        background: "rgba(255,255,255,0)",
                        height:"100%",
                        width:"100%",     
                        border: "0px solid #AAAAAA",
                        paddingBottom:
                        {
                          xl:"0px",
                        }

                      }}
                    >
                      {tile.ListAgentMlsId === "WILLSDO"?
                      <Image src={"profilepics/profile-round-lowres.png"} bgColor="rgba(255,255,255,0)" fit="contain" duration={200}/>              
                        :null}
                    </Grid>

                    </Grid>
                </Grid>            
                
                  }
                mdlTxtColor={ "black"}
                mdlTxtSize={["1rem", "1rem", "1rem"]}
                mdlTxtType={"normal"}
                mdlTxtAlign={"center"}
                mdlHorizontalAlign={"center"}
                mdlVerticalAlign={"flex-end"}
                mdlBgColor={ "#FFFFFF" }
                mdlBorder={ "0px solid black"}
                mdlHeight={["75px", tile.ListAgentMlsId === "WILLSDO" ? "20%" : "15%", tile.ListAgentMlsId === "WILLSDO" ? "20%" : "20%"]}
                mdlGraphType={null}
                mdlGraphData={null}                
                btmPadding={"0px"}
                btmPicture={null}
                btmPictureAlign={null}
                btmTxt={ 
                  <center>
                    <div style={{fontSize:".5rem"}}>
                    <img alt="image" src="howardhanna/idx-logo-sm.png" height="10px"/>  MLS:  {tile.mls} - Listing By {tile.broker}
                    </div>
                  </center>      
                }
                btmTxtColor={ "black"}
                btmTxtSize={[".75rem", ".75rem", ".75rem"]}
                btmTxtType={"normal"}
                btmTxtAlign={"left"}
                btmHorizontalAlign={"center"}
                btmVerticalAlign={"center"}
                btmBgColor={ "#FFFFFF" }
                btmBorder={"0px solid black"}
                btmHeight={["25px", tile.ListAgentMlsId === "WILLSDO" ? "5%" : "10%", tile.ListAgentMlsId === "WILLSDO" ? "5%" : "5%"]}
                btmGraphType={null}
                btmGraphData={null}
                border={ "1px solid #AAAAAA" }
                shadow={4}
                downloads={""}
                linksTo={""}
                growTime={4000}
                padding={"0px"}
                borderRadius={"20px"}
                bgcolor={"rgba(255,255,255,1)"}
              />
          </Grid>
          );
  };

  getIdxTile = () => {
    return (
      <React.Fragment>
        <Grid
          item
          sx={{
            background: "rgba(255,255,255,0)",
            padding: "0px",
            height: {
              xl: "10%",
              lg: "15%",
              md: "15%",
              sm: "50%",
            },
            border:"0px solid black"
          }}
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <CommonTile
            animationType={null}
            animationTime={null}
            tagPicture={null}
            tagTxt={null}
            tagTxtColor={"black"}
            tagTxtSize={["12px", "12px", "16px"]}
            tagTxtType={"bold"}
            tagTxtAlign={"center"}
            tagVerticalAlign={"flex-start"}
            tagHorizontalAlign={"flex-end"}
            tagBgColor={"#73be73"}
            tagBorder={"0px solid black"}
            tagBorderRadius={"0px"}
            topPadding={"0px"}
            topPicture={null}
            topPictureAlign={"left"}
            topPictureSize={"0px"}
            topTxt={null}
            topTxtColor={"black"}
            topTxtSize={["0px", "0px", "0px"]}
            topTxtType={"normal"}
            topTxtAlign={"left"}
            topHorizontalAlign={"center"}
            topVerticalAlign={"center"}
            topBgColor={"rgba(255,255,255,0)"}
            topHeight={["0px", "0%", "0%"]}
            topGraphType={null}
            topGraphData={null}
            mdlPadding={"0px"}
            mdlPicture={null}
            mdlPictureAlign={null}
            mdlTxt={null}
            mdlTxtColor={"black"}
            mdlTxtSize={["0px", "0px", "0px"]}
            mdlTxtType={"bold"}
            mdlTxtAlign={"center"}
            mdlHorizontalAlign={"center"}
            mdlVerticalAlign={"flex-start"}
            mdlBgColor={"rgba(255,255,255,0)"}
            mdlBorder={"0px solid black"}
            mdlHeight={["0px", "0%", "0%"]}
            mdlGraphType={null}
            mdlGraphData={null}
            btmPadding={"0px"}
            btmPicture={null}
            btmPictureAlign={null}
            btmTxt={
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          background: "rgba(255,255,255,0)",
                          height:"100%",
                          width:"100%",     
                          border: "0px solid #AAAAAA",
                        }}
                      >
                        <Grid
                          item
                          sx={{
                            background: "rgba(255,255,255,0)",
                            overflowX:"hidden",
                            textAlign:"right",
                            fontSize: {
                              xs:"1rem",
                              sm:"1rem",
                              md:"1rem",
                              lg:"1rem",
                              xl:"1rem"
                            },
                            height:"100%",
                            width:"100%",   
                            border:"0px solid black",
                            fontWeight:"normal",
                          }}
                          xs={2}
                          sm={2}
                          md={1}
                        >
                            <img alt="image" src="howardhanna/idx-lg.png" height={25} width={40}/>&nbsp;&nbsp;
                        </Grid>
                        <Grid
                          item
                          sx={{
                            background: "rgba(255,255,255,0)",
                            overflowX:"hidden",
                            textAlign:"left",
                            fontSize: {
                              xs:".55rem",
                              sm:".55rem",
                              md:".55rem",
                              lg:".55rem",
                              xl:".55rem"
                            },
                            height:"100%",
                            width:"100%",   
                            fontWeight:"normal",
                          }}
                          xs={10}
                        >                          
                          The data relating to real estate on this web site comes in part from the Internet Data Exchange (IDX) 
                          Program of NYSAMLS’s. Real estate listings held by firms other than Howard Hanna Real Estate Services, are marked 
                          with the Listing Broker’s Firm Name. Data provided is for consumers’ personal, non-commercial use and 
                          may not be used for any purpose other than to identify prospective properties that consumers may be 
                          interested in purchasing. Listing Data last updated at [timestamp]. 
                          <br/>
                          Disclaimer: All information deemed reliable but not guaranteed and should be independently verified. All 
                          properties are subject to prior sale, change or withdrawal. Neither the listing broker(s) nor Howard Hanna Real 
                          Estate Services shall be responsible for any typographical errors, misinformation, misprints, and shall be held 
                          totally harmless. © 2024 CNYIS, UNYREIS, WNYREIS. All rights reserved.
                        </Grid>
                        <Grid
                          item
                          sx={{
                            background: "rgba(255,255,255,0)",
                            overflowX:"hidden",
                            textAlign:"right",
                            fontSize: {
                              xs:"1rem",
                              sm:"1rem",
                              md:"1rem",
                              lg:"1rem",
                              xl:"1rem"
                            },
                            height:"100%",
                            width:"100%",   
                            border:"0px solid black",
                            fontWeight:"normal",
                          }}
                          xs={0}
                          sm={0}
                          md={1}
                        >
                        </Grid>
                        </Grid>
            }
            btmTxtColor={"black"}
            btmTxtSize={["1rem", ".75rem", ".75rem"]}
            btmTxtType={"normal"}
            btmTxtAlign={"justify"}
            btmHorizontalAlign={"flex-end"}
            btmVerticalAlign={"flex-start"}
            btmBgColor={"rgba(255,255,255,0)"}
            btmBorder={"0px solid black"}
            btmHeight={["425px", "100%", "100%"]}
            btmGraphType={null}
            btmGraphData={null}
            border={"0px solid black"}
            shadow={0}
            downloads={""}
            linksTo={""}
            growTime={4000}
            padding={"10px"}
            borderRadius={"20px"}
            bgcolor={"rgba(255,255,255,0)"}
          />
        </Grid>
      </React.Fragment>
    );
  };

  render() {

 
    return (
      <Drawer
          anchor="bottom"
          open={this.props.showFeatured}
          onClose={this.props.toggleFeatured}
          ModalProps={{
            // Setting this prop to false will create a non-modal drawer
            hideBackdrop: true,
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
            // Setting this prop to false will create a non-modal drawer
            disablePortal: true,
          }}
          variant="persistent"
          PaperProps={{
            sx: {
              height: {
                xs: "77%",
                sm: "77%",
                md: "73%",
                lg: "74%",
                xl: "74%",
              },
              width: {
                xs: "100%",
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "100%",
              },
              border: "0px solid gray",

              marginLeft: "auto",
              pointerEvents:"auto",
              zINdex:this.props.zindex,
              borderTop:"2px solid " + this.props.theme.bannerColor,

              
              backgroundImage: "url('"+ this.props.theme.background +"')",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            },
          }}
        >
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{
          
          
          height: {
            xs: "100%",
          },
          width: {
            xs: "100%",
          },
          
          borderTop:{
            xs:"1px solid #AAAAAA",
            sm: "0px solid #333333"
          }
        }}
      >

            <Grid
              item
              sx={{
                padding: "0px",
                height: {
                  xl: "100%",
                  lg: "100%",
                  md: "100%",
                  sm: "100%",
                },
                overflowY: "auto",
                overflowX: "hidden",
                fontSize: "16px",
                border: "0px solid red",
                
              }}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
            >
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={{
                  height: "100%",
                  
                  border: "0px solid #333333",
                }}
              >   

                {this.createSection(
                this.FeaturedListingsMultifamilySection)}

            </Grid>
        </Grid>
      </Grid>
      </Drawer>
    );
  }
}

export default FeaturedListingsMultifamily;
